// Safe return path after sign-in: only a same-origin path that starts with a single "/"
// and is not an auth route. Anything else goes to /app.
const AUTH_ROUTES = ['/login', '/register', '/forgot-password', '/reset-password', '/verify-email', '/auth/']
const FALLBACK = '/app'
const REMEMBER_KEY = 'zupa-auth-next'

function isSafe(raw: string): boolean {
  if (!raw.startsWith('/') || raw.startsWith('//')) return false
  if (/[\\\s]/.test(raw)) return false
  const path = raw.split(/[?#]/)[0]
  return !AUTH_ROUTES.some((route) => (route.endsWith('/') ? path.startsWith(route) : path === route || path.startsWith(`${route}/`)))
}

export function safeNext(raw: string | null | undefined): string {
  return raw && isSafe(raw) ? raw : FALLBACK
}

export function loginPathFor(pathname: string, search = ''): string {
  return `/login?next=${encodeURIComponent(`${pathname}${search}`)}`
}

export function postLoginPath(
  user: { is_pro?: boolean } | null | undefined,
  status: { is_onboarded?: boolean } | null | undefined,
  next: string | null | undefined,
): string {
  if (user?.is_pro && status && !status.is_onboarded) return '/onboarding'
  return safeNext(next)
}

// Google leaves the app for its consent screen, so the next path waits in sessionStorage.
export function rememberNext(next: string | null | undefined): void {
  try {
    if (next && isSafe(next)) sessionStorage.setItem(REMEMBER_KEY, next)
    else sessionStorage.removeItem(REMEMBER_KEY)
  } catch {
    // storage unavailable: the callback falls back to /app
  }
}

export function takeRememberedNext(): string | null {
  try {
    const next = sessionStorage.getItem(REMEMBER_KEY)
    sessionStorage.removeItem(REMEMBER_KEY)
    return next && isSafe(next) ? next : null
  } catch {
    return null
  }
}
